// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Wire enum for the server "VariableType" type (members + integer values are the
// wire contract). The hand facade in app/common re-exports this and hosts any
// non-derivable helpers; see design/wiki/wire-schemas.md.
export enum VariableType {
  None = 0,
  Text = 1,
  Url = 2,
  Boolean = 4,
  Organisation = 5,
}
